$(document).ready(function () {

    $("table").not(".calendar__calendar table").wrap("<div class='table'></div>");

});